import { type JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

/**
 * Route guard for /agent/* pages. Mirrors RequireAgent on the
 * backend: only users with role='agent' get through. Anyone else
 * lands on HomeRedirect (which routes them to wherever their role
 * actually lives — admin/dashboard, dashboard, or login).
 *
 * The backend's RequireAgent middleware is the security gate; this
 * one is just the UX gate so a non-agent typing /agent/commissions
 * doesn't render an empty 403 shell.
 */
export function RequireAgentRoute(): JSX.Element {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    // Auth still resolving — render nothing rather than flash to
    // login. ProtectedRoute already handled the no-token case.
    return <></>;
  }
  if (user?.role !== 'agent') {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
